import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  datasetXY,
  backgroundColor,
  tooltip,
  discreteLegend,
  color,
  pivotAdapter,
  initPivot,
  datasetPivot,
  pivotIndicators,
  pivotDiscreteLegend,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotRowDimensions,
  pivotColumnDimensions,
  stackInverse,
  verticalCrosshairRect,
  initRose,
  roseAnimation,
  radiusAxis,
  progressive,
  linearColor,
  colorAdapter,
  pivotColorLegend,
  colorLegend,
  roseStyle,
  colorRoseStyleFill,
  labelPie,
  pivotHideIndicatorName,
  pivotTitle,
  addRegionPadding,
  dimensionLinkage,
  fontFamilyTheme,
} from '../pipes'

const rose: VChartSpecPipeline = [
  fontFamilyTheme,
  initRose,
  roseAnimation,
  stackInverse,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetXY,
  animationMorph,
  progressive,
  radiusAxis,
  verticalCrosshairRect,
  colorRoseStyleFill(roseStyle),
  colorAdapter(discreteLegend, colorLegend),
  labelPie,
  tooltip({ titleEncoding: 'angle' }),
]

const pivotRose: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  pivotHideIndicatorName,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initRose,
    roseAnimation,
    addRegionPadding,
    stackInverse,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetXY,
    animationMorph,
    progressive,
    radiusAxis,
    verticalCrosshairRect,
    colorRoseStyleFill(roseStyle),
    labelPie,
    tooltip({ titleEncoding: 'angle' }),
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const roseSpecPipeline = [pivotAdapter(rose, pivotRose)]
